module.exports = __webpack_public_path__ + "img/feedback.03f43a57.svg";